<template>
  <sub-frame title="订单详情">
    <div slot="head">
      <mt-button
        icon="more"
        v-if="actions.length"
        type="primary"
        @click="sheetVisible = !sheetVisible"
      ></mt-button>
    </div>
    <div>
      <mt-cell title="订单号" :value="apply.orderNo"></mt-cell>
      <mt-cell title="提交时间" :value="apply.createTime"></mt-cell>
      <mt-cell title="分开公证" :value="apply.pdfApart"></mt-cell>
      <mt-cell title="订单来源" :value="apply.origin"></mt-cell>
      <mt-cell
        title="订单状态"
        :value="apply.status"
        v-if="!apply.hasNotarization"
      ></mt-cell>
      <mt-cell
        title="订单状态"
        :value="apply.status + ', 查看公证书'"
        :to="`/apply/notarization?applyGuid=${apply.guid}`"
        v-else
        is-link
      >
      </mt-cell>
      <mt-cell
        title="邮寄信息"
        :value="apply.deliveryDisabled"
        :to="`/apply/mail?applyGuid=${apply.guid}`"
        is-link
      >
      </mt-cell>
      <mt-cell
        title="标的物信息"
        :value="apply.subject"
        :to="`/apply/subject?applyGuid=${apply.guid}`"
        is-link
      >
      </mt-cell>
      <mt-cell
        v-for="(seller, i) in sellers"
        :key="seller.guid"
        :title="'转让方信息' + (i ? `(${i + 1})` : '')"
        :value="seller.name"
        :to="roleUrl(seller)"
        is-link
      >
      </mt-cell>
      <template v-for="(buyer, i) in buyers">
        <mt-cell
          :key="buyer.guid"
          :title="'受让方信息' + (i ? `(${i + 1})` : '')"
          :value="buyer.name"
          :to="roleUrl(buyer)"
          is-link
        >
        </mt-cell>
      </template>
    </div>
    <div class="sectext">{{ apply.warning }}</div>
    <mt-actionsheet :actions="actions" v-model="sheetVisible" />
  </sub-frame>
</template>

<script>
import applyStatusMap from "@/assets/applyStatusMap";
import applyMailStatusMap from "@/assets/applyMailStatusMap";

export default {
  name: "ApplyDetail",
  data() {
    return {
      sheetVisible: false,
      actionsAll: [
        {
          code: "setas_submit_from_approve",
          from: "待制证",
          name: "设为待审批",
          method: () => this.setasWithConfirm("Submit", "待审批"),
        },
        {
          code: "setas_changemail_from_approve",
          from: "邮寄变更",
          name: "设为待审批",
          method: () => this.setasWithConfirm("Submit", "待审批"),
        },
        {
          code: "setas_reject_from_submit",
          from: "待审批",
          name: "设为已驳回",
          method: this.setasReject,
        },
        {
          code: "setas_approve_from_submit",
          from: "待审批",
          name: "设为待制证",
          method: () => this.setasWithConfirm("Approve", "待制证"),
        },
        {
          code: "setas_approve_from_printed",
          from: "待发证",
          name: "设为待制证",
          method: () => this.setasWithConfirm("Approve", "待制证"),
        },
        {
          code: "setas_printed_from_approve",
          from: "待制证",
          name: "设为待发证",
          method: () => this.setasWithConfirm("Printed", "待发证"),
        },
        {
          code: "setas_printed_from_mailed",
          from: "待计费",
          name: "设为待发证",
          method: () => this.setasWithConfirm("Printed", "待发证"),
        },
        {
          code: "setas_changemail_from_approve",
          from: "邮寄变更",
          name: "设为待计费",
          method: () => this.setasWithConfirm("Mailed", "待计费"),
        },
        {
          code: "setas_mailed_from_printed",
          from: "待发证",
          name: "设为待计费",
          method: () => this.setasWithConfirm("Mailed", "待计费"),
        },
        {
          code: "setas_mailed_from_paid",
          from: "已完结",
          name: "设为待计费",
          method: () => this.setasWithConfirm("Mailed", "待计费"),
        },
        {
          code: "setas_paid_from_mailed",
          from: "待计费",
          name: "设为已完结",
          method: () => this.setasWithConfirm("Paid", "已完结"),
        },
      ],
      suggestion: "",
      apply: {
        guid: this.$route.query.applyGuid,
        origin: "",
        orderNo: "",
        status: "",
        createTime: "",
        pdfApart: "",
        deliveryDisabled: "",
        subject: "",
        applicants: [],
        notarizationGuid: "",
      },
    };
  },
  computed: {
    sellers() {
      return this.apply.applicants.filter((a) => a.role === "卖方");
    },
    buyers() {
      return this.apply.applicants.filter((a) => a.role === "买方");
    },
    actions() {
      let rights = this.$store.state.notaryRights;
      let filter = (...allows) =>
        this.actionsAll.filter((a) => {
          let allow =
            allows.includes(a.name) &&
            rights[a.code] &&
            a.from === this.apply.status;
          if (
            a.code === "setas_mailed_from_printed" &&
            this.apply.deliveryDisabled === "暂不邮寄"
          ) {
            allow = false;
          }
          return allow;
        });
      switch (this.apply.status) {
        case "待审批":
          return filter("设为待制证", "设为已驳回");
        case "待制证":
          return filter("设为待发证", "设为待审批");
        case "待发证":
          return filter("设为待制证", "设为待计费");
        case "邮寄变更":
          return filter("设为待计费", "设为待审批");
        case "待计费":
          return filter("设为待发证", "设为已完结");
        case "已完结":
          return filter("设为待计费");
        default:
          return [];
      }
    },
  },
  created() {
    this.getApplyDetail();
  },
  methods: {
    roleUrl(applicant) {
      let type;
      let isPerson = applicant.kind === "个人";
      if (applicant.role === "卖方")
        type = isPerson ? "personseller" : "companyseller";
      else type = isPerson ? "personbuyer" : "companybuyer";
      return `/apply/${type}?applyGuid=${this.apply.guid}&applicantGuid=${applicant.guid}`;
      // http://192.168.100.197:9996
      // return `/${type}?applyGuid=${this.apply.guid}&applicantGuid=${applicant.guid}`;
    },
    async getApplyDetail() {
      let res = await this.$axios.get(`/applycheck/applydetail`, {
        params: {
          guid: this.apply.guid,
        },
      });
      let d = res.data;
      this.apply = {
        ...d,
        createTime: d.createTime.replace(/t/i, " ").substr(0, 16),
        pdfApart: d.pdfApart ? "分开公证" : "不分开",
        status: applyStatusMap.filter((s) => s.code === d.status)[0].label,
        deliveryDisabled: applyMailStatusMap[d.deliveryDisabled],
        hasNotarization: ["Approve", "Printed", "Mailed", "Paid"].includes(
          d.status
        ),
      };
    },
    async setas(parms) {
      let res = await this.$axios.post(`/applycheck/applyworkflow`, {
        ...parms,
        applyGuid: this.apply.guid,
      });
      if (res.data.error) {
        return this.$toast(res.data.error);
      } else {
        this.apply.status = parms.targetStatusTxt;
        this.apply.hasNotarization = false;
        this.$toast("已设为" + parms.targetStatusTxt);
      }
    },
    async setasWithConfirm(status, desc) {
      await this.$messagebox.confirm(`确定要设为${desc}吗？`);
      this.setas({
        targetStatus: status,
        targetStatusTxt: desc,
      });
    },
    async setasReject() {
      let { value, action } = await this.$messagebox.prompt(
        "请填写审批意见（不小于4字）",
        "驳回申请"
      );
      if (action !== "confirm") return;
      if (!value || value.trim().length < 4) return this.$toast("未作修改");
      this.setas({
        targetStatus: "Reject",
        targetStatusTxt: "已驳回",
        suggest: value,
      });
    },
  },
};
</script>

<style scoped lang="scss">
::v-deep .subframe-body {
  .sectext {
    margin: 10px;
    color: #ccc;
  }
}
.action-group {
  width: 100%;
  .btn-group {
    padding: 10px;
    display: flex;
    flex-direction: column;
    width: 100%;
    justify-content: space-around;
    align-items: center;
    button {
      width: 100%;
      margin: 5px 0;
    }
  }
}
</style>
